<div #mapSelectCoordsContainer
     class="map-container"
     (click)="$event.stopPropagation()">
</div>
